import { sendMagicLink } from '../magicLinkHandle';

// var urlBase = process.env.NEXT_PUBLIC_BASE_URL;

import config from '@/localconfig';
const urlBase = config.BASE_URL;

const login = (email) => {
  sendMagicLink(email.email);
};

const signup = (body) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  };
  return fetch(urlBase + '/api/v1/users/signup', requestOptions);
};

const getFamilyMembers = () => {
  return fetch(`${urlBase}/api/v1/members`);
};

const getUserProfile = () => {
  return fetch(`${urlBase}/api/v1/users/profile`);
};

const saveMeasurement = (path, body) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  return fetch(urlBase + `/api/v1/measurements/${path}`, requestOptions);
};

// New function for saving anonymous measurements
const saveAnonymousMeasurement = (path, body) => {
  // Get or create session ID from localStorage
  let sessionId = localStorage.getItem('lm_anonymous_session_id');
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem('lm_anonymous_session_id', sessionId);
  }

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-ID': sessionId,
    },
    body: JSON.stringify(body),
  };
  return fetch(urlBase + `/api/v1/anonymous/measurements/${path}`, requestOptions);
};

// Get anonymous measurements by session ID
const getAnonymousMeasurements = (sessionId) => {
  return fetch(`${urlBase}/api/v1/anonymous/measurements/session/${sessionId}`);
};

// Migrate anonymous measurements to user account
const migrateAnonymousMeasurements = (sessionId, userId, familyMemberId) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sessionId,
      userId,
      familyMemberId
    }),
  };
  return fetch(urlBase + '/api/v1/anonymous/measurements/migrate', requestOptions);
};

// Generate a unique session ID
const generateSessionId = () => {
  return 'lm_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// Get current anonymous session ID
const getAnonymousSessionId = () => {
  return localStorage.getItem('lm_anonymous_session_id');
};

const addFamilyMember = (body) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  return fetch(urlBase + `/api/v1/members`, requestOptions);
};

const removeFamilyMember = (id) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return fetch(`${urlBase}/api/v1/members/${id}`, requestOptions);
};

const getMeasurementsOfMember = (memberId) => {
  return fetch(urlBase + `/api/v1/measurements/member/${memberId}`);
};
// const getMeasurementsOfMemberData = (memberId) => {
//   return fetch(urlBase + `/api/v1/measurements/member/${memberId}`);
// };

async function doesEmailExist(email) {
  try {
    const response = await fetch(urlBase + '/api/v1/users/check-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    const data = await response.json();
    return data.exists;
  } catch (error) {
    console.error('Error checking email existence:', error);
    return false;
  }
}

export {
  login,
  getFamilyMembers,
  saveMeasurement,
  saveAnonymousMeasurement,
  getAnonymousMeasurements,
  migrateAnonymousMeasurements,
  getAnonymousSessionId,
  addFamilyMember,
  signup,
  removeFamilyMember,
  getMeasurementsOfMember,
  // getMeasurementsOfMemberData,
  doesEmailExist,
  getUserProfile,
};
